<div *ngIf="studyArea" class="list-item-container">
  <div class="list-item-text-box">
    <div class="list-item-left-section-box basin-align-items-start">
      <div class="basin-body line-height-normal primary-line basin-display-block basin-align-items-center">
        {{studyArea.studyAreaName}}
      </div>
      <div class="sub-line secondary-line basin-display-flex basin-align-items-center">{{ studyArea.areaMeasurement |
        number: '1.0-1' }} {{ studyArea.areaUnit }}
      </div>

    </div>
    <div class="list-item-right-section-box" *ngIf="studyArea.hasTerrain">

      <div class="p-d-flex p-jc-center p-ai-center basin-color-black basin-height-100">
        <div ptooltip="Terrain File Uploaded" class="p-element symbol-landscape-2 outlined basin-pl-8"
          ng-reflect-content="Terrain File Uploaded">

        </div>
      </div>

    </div>
  </div>

  <div class="list-item-text-box">
    <div class="list-item-left-section-box sub-line">
      <div class="tertiary-line basin-display-flex basin-align-items-center basin-mt-1">
        {{ (studyArea.creationTimestamp | appDate) }}
      </div>

      <div class="tertiary-line">
        Created By: {{studyArea.firstName + ' ' + studyArea.lastName}}
      </div>
      <div class="sub-line tertiary-line shared-with-line" *ngIf="studyArea.shared">
        <span class="shared-label">Shared With:</span>
        <span class="shared-name" [title]="studyArea.dfpSpecialist">
          {{ studyArea.dfpSpecialist }}
        </span>

        <button *ngIf="isAbleToEditDfpSpecialist" pButton type="button" class="p-button-text edit-btn"
          (click)="ChangeDfpSpecialist(studyArea)">
          <span class="icon-edit"></span>
        </button>
      </div>

    </div>
    <div class="list-item-right-section-box basin-mt-1">
      <!-- Toggle Button: Private / Shared -->
      <div class="basin-display-flex basin-flex-row basin-align-items-center basin-mt-3"
        *ngIf="studyArea.global !== true && isAbleToShareStudyArea == true" (click)="$event.stopPropagation()"
        (keydown)="onDivKeyDown($event)">
        <p-inputSwitch [(ngModel)]="checked" inputId="PrivateSharedArea"
          (onChange)="onToggleChange(studyArea)"></p-inputSwitch>

        <p class="basin-ml-1 sub-line">{{ statusText }}</p>

      </div>
    </div>
  </div>
</div>